export default __webpack_public_path__ + "static/media/temperature.7936d48b.svg";